import { JDSMenuBlockItemProps } from './generated';

export interface MenuBlockItemProps
  extends Omit<JDSMenuBlockItemProps, 'selected' | 'onSelect'> {
  value?: string;
  onSelect?: (index?: number) => void;
  selectedIndex?: number;
}

interface InternalMenuBlockItemProps extends MenuBlockItemProps {
  internalIndex?: number;
  _hasIcon?: boolean;
}

export const withLogic =
  (
    Component: React.ComponentType<MenuBlockItemProps>
  ): React.FC<MenuBlockItemProps> =>
  (props: MenuBlockItemProps) => {
    const internalProps: InternalMenuBlockItemProps = props;
    const selected = internalProps.internalIndex === props.selectedIndex;

    const handleSelect = () => {
      props.onSelect?.(internalProps.internalIndex);
    };
    return (
      <Component
        {...{
          ...props,
          selected,
          _hasIcon: internalProps._hasIcon || Boolean(props.prefix),
          onSelect:
            !props.type || props.type === 'entry' ? handleSelect : undefined,
          prefix:
            props.prefix || (internalProps._hasIcon ? <div></div> : undefined)
        }}
      />
    );
  };
